import {
  Grid
} from '@mui/material';
import { useContext } from 'react';
import ContractTypes from './ContractTypes';
import ProjectTags from './ProjectTags';
import { KickOffContext } from '@/Contexts/KickOff';
import ProjectSettings from '@/components/ProjectSettings';

const Configurations: React.FC = () => {
  const { projectSettings, setProjectSettings } = useContext(KickOffContext);
  return (
    <Grid size={12} container>
      <ContractTypes />
      <ProjectTags />
      <Grid size={12}>
        <ProjectSettings
          settings={projectSettings}
          onSettingsChange={setProjectSettings}
        />
      </Grid>
    </Grid>
  );
}

export default Configurations;
